import React, { useState } from 'react';
import { PhoneIcon, MessageSquareIcon, MapPinIcon, BadgeCheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SITE } from '../constants/site';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  const year = new Date().getFullYear();
  return <footer className="w-full bg-nfblue-dark text-slate-300" data-id="element-60" data-mp="36nd4feb5q41k">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-id="element-61" data-mp="3ug3gromz2pcd">
        <div className="grid gap-10 md:grid-cols-3" data-id="element-62" data-mp="38h3r5ed5aiu">
          <div className="flex flex-col items-center text-center" data-id="element-63" data-mp="37xyao5wgelp">
            <img src={SITE.logoUrl} alt={`${SITE.shortName} logo`} className="h-20 w-auto" data-id="element-64" data-mp="3ldalzbekzvhs" />
            <p className="mt-4 max-w-sm text-sm text-slate-400" data-id="element-65" data-mp="3qcniknv98gxk">
              {SITE.company}. Local, licensed, and insured irrigation experts serving
              Garland, TX and all of North Texas.
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold" data-id="element-66" data-mp="2ez1l8ff8r90y">
              <span className="flex items-center gap-1.5 text-nfgreen-light" data-id="element-67" data-mp="3labqttpu02pb">
                <BadgeCheckIcon className="h-4 w-4" data-id="element-68" data-mp="3gb8xh6j7rkx6" />
                License {SITE.license}
              </span>
              <span className="flex items-center gap-1.5 text-nfgreen-light" data-id="element-69" data-mp="3v8hqs5s2uyrj">
                <ShieldCheckIcon className="h-4 w-4" data-id="element-70" data-mp="3q8dk17gz1iei" />
                Fully Insured
              </span>
            </div>
          </div>

          <div data-id="element-71" data-mp="817b9zwxjeqw">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-72" data-mp="80xmugrj9fnb">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm" data-id="element-73" data-mp="htd236bg3q4i">
              <li data-id="element-74" data-mp="hs1wd0yfw8ar">
                <a href={SITE.phoneHref} className="flex items-center gap-2 transition-colors hover:text-white" data-id="element-75" data-mp="huo87csd59ys">
                  <PhoneIcon className="h-4 w-4 text-nfgreen-light" data-id="element-76" data-mp="qt8hxofy49av" />
                  {SITE.phone}
                </a>
              </li>
              <li data-id="element-77" data-mp="mt7rt6jhi9nz">
                <a href={SITE.smsHref} className="flex items-center gap-2 transition-colors hover:text-white" data-id="element-78" data-mp="mtrc2twlxa56">
                  <MessageSquareIcon className="h-4 w-4 text-nfgreen-light" data-id="element-79" data-mp="tt0a6tpgcss2" />
                  Text us anytime
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-80" data-mp="13t0sqdfhz4v7">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-nfgreen-light" data-id="element-81" data-mp="13rg0wvkki011" />
                Garland, TX & All of North Texas
              </li>
            </ul>
          </div>

          <div data-id="element-82" data-mp="1clcma85wr8fe">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-83" data-mp="1cnyp5uhuszra">
              Business Hours
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-slate-400" data-id="element-84" data-mp="1mjilgi0by0gk">
              <li className="flex justify-between" data-id="element-85" data-mp="1riv4ero2yndv">
                <span data-id="element-86" data-mp="1rid1jc6wxawz">Monday - Saturday</span>
                <span className="font-semibold text-white" data-id="element-87" data-mp="3ob5681tmoz4l">6:00 AM – 7:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-88" data-mp="3ta86l8ynyh68">
                <span data-id="element-89" data-mp="3tars0znivnp0">Sunday</span>
                <span className="font-semibold text-white" data-id="element-90" data-mp="3tc2tutxeqldh">7:00 AM – 5:00 PM</span>
              </li>
            </ul>

            <h3 className="mt-8 font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-91" data-mp="25onbfv030xrz">
              About Us
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-92" data-mp="21nla98mlubnd">
              Established April 20, 2022, Northface Irrigation Repair & Services, LLC is your comprehensive solution for all things outdoor. Based in Garland, we specialize in a full spectrum of landscape services, from expert irrigation system repair and drainage solutions to stunning landscape design and tree services.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row" data-id="element-93" data-mp="2fe6y7bqx1bs4">
          <p data-id="element-94" data-mp="18z63189psxml">
            © {year} {SITE.company}. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-95" data-mp="13ys0g5qvufvy">
            <button onClick={() => setModal('privacy')} className="transition-colors hover:text-white" data-id="element-96" data-mp="1414ew8xfm849">
              Privacy Policy
            </button>
            <button onClick={() => setModal('terms')} className="transition-colors hover:text-white" data-id="element-97" data-mp="2wnhllw1cjwc1">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <LegalModal open={modal === 'privacy'} onClose={() => setModal(null)} title="Privacy Policy" data-id="element-98" data-mp="2ntcmkpc27elf">
        <div className="space-y-4" data-id="element-99" data-mp="3bkrwb3660y6p">
          <p data-id="element-100" data-mp="3bki73hsy2v22">
            {SITE.company} ("we," "us," or "our") respects your privacy. This policy
            explains how we collect, use, and protect the information you provide when
            you contact us or request service.
          </p>
          <div data-id="element-101" data-mp="36k444e67abaw">
            <h4 className="font-bold text-slate-900" data-id="element-102" data-mp="36jkox57xq10k">Information We Collect</h4>
            <p className="mt-1" data-id="element-103" data-mp="1q5uhbohlwum6">
              We collect the information you voluntarily provide — such as your name,
              phone number, service address, and details about your property — when you
              call, text, or request an estimate. We use this solely to schedule visits,
              provide quotes, and deliver our irrigation services.
            </p>
          </div>
          <div data-id="element-104" data-mp="1wn5ritmuavro">
            <h4 className="font-bold text-slate-900" data-id="element-105" data-mp="1wmvxmuyoc4gp">How We Use Your Information</h4>
            <p className="mt-1" data-id="element-106" data-mp="1rn1bf4pug31z">
              Your information is used to respond to inquiries, schedule and perform
              work, send quotes and invoices, and follow up on completed jobs. We do not
              sell or rent your personal information to third parties.
            </p>
          </div>
          <div data-id="element-107" data-mp="1do1jno71b81l">
            <h4 className="font-bold text-slate-900" data-id="element-108" data-mp="1dojr7gz5d8ot">Text Messaging</h4>
            <p className="mt-1" data-id="element-109" data-mp="18wjip050h7gm">
              If you text us, your mobile number is used only to communicate about your
              service request. Message and data rates may apply. You may opt out at any
              time by replying STOP.
            </p>
          </div>
          <div data-id="element-110" data-mp="2gan75yt2jgyo">
            <h4 className="font-bold text-slate-900" data-id="element-111" data-mp="2gb5d5n5j99js">Contact</h4>
            <p className="mt-1" data-id="element-112" data-mp="2g8j41j2zulzg">
              Questions about this policy? Call or text us at {SITE.phone}.
            </p>
          </div>
        </div>
      </LegalModal>

      <LegalModal open={modal === 'terms'} onClose={() => setModal(null)} title="Terms of Service" data-id="element-113" data-mp="2q0ypiqdi1sp3">
        <div className="space-y-4" data-id="element-114" data-mp="2uz07t933pnzi">
          <p data-id="element-115" data-mp="1xbrfov8lhgoj">
            These terms govern the services provided by {SITE.company}, Texas State
            Irrigation License {SITE.license}. By requesting service, you agree to the
            following.
          </p>
          <div data-id="element-116" data-mp="279flqhbniam0">
            <h4 className="font-bold text-slate-900" data-id="element-117" data-mp="278w3ezi39k7g">Diagnostics & Quotes</h4>
            <p className="mt-1" data-id="element-118" data-mp="2bc26xzdtgxa8">
              Quotes are based on the conditions observed at the time of our
              professional diagnostic inspection. Additional issues discovered during work may affect the final
              scope and price, which we will communicate before proceeding.
            </p>
          </div>
          <div data-id="element-119" data-mp="1b22jjis0y1z7">
            <h4 className="font-bold text-slate-900" data-id="element-120" data-mp="1b2ucelu8llls">Workmanship & Warranty</h4>
            <p className="mt-1" data-id="element-121" data-mp="17323u94uffgf">
              We stand behind our work. If a repair we made or a system we installed
              fails due to our workmanship, we will return and make it right.
              Manufacturer warranties on parts and equipment are passed through to the
              customer where applicable.
            </p>
          </div>
          <div data-id="element-122" data-mp="ndrpaygu30jw">
            <h4 className="font-bold text-slate-900" data-id="element-123" data-mp="nd9u855wqsdk">Insurance & Liability</h4>
            <p className="mt-1" data-id="element-124" data-mp="jc6hvsn2jeh3">
              Northface Irrigation carries full workman's insurance on every job. This
              protects you from liability related to worker injury or unexpected damage
              during the course of our work.
            </p>
          </div>
          <div data-id="element-125" data-mp="2do4mtiecho76">
            <h4 className="font-bold text-slate-900" data-id="element-126" data-mp="28r4hxat8erhn">Contact</h4>
            <p className="mt-1" data-id="element-127" data-mp="28rw2zrp7d6to">
              For questions about these terms, call or text us at {SITE.phone}.
            </p>
          </div>
        </div>
      </LegalModal>
    </footer>;
}